import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { v4 } from 'uuid';
import { Analytics, bleachrHTTP } from '../_classes';
import { SessionService } from './session.service';
import { SsrLocalstoreService } from './ssr-localstore.service';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    private analytics = new Analytics()

    constructor(
        private http: bleachrHTTP,
        private sessionService: SessionService,
        private ssr: SsrLocalstoreService
    ) { }

    initFingerPrint() {
        if (!this.ssr.getItem('tennisOne-fingerprint')) {
            this.ssr.setItem('tennisOne-fingerprint', `web-${v4()}`)
        }
    }

    postEvent(event_key: string, event = {}) {
        if (this.ssr.isClientSide) {

            if (location.hostname.includes('localhost')) {
                return
            }

            try {
                const payload = this.analytics.createEvent(event_key, event)
                return this.http.post(environment.ANALYTIC_ENDPOINT, payload, { type: 'auth' })
                    .then(() => {
                        // We want to update our total session and tournament session (only when user does not exit a tournament by clicking on the exit btn)
                        // "session_end_local" each time a postEvent is executed.
                        this.sessionService.updateTotalSessionEndLocal(new Date().toISOString())
                    })
                    .catch((err) => {
                        console.error(err)
                        throw err
                    })

            } catch (err) {
                throw err
            }
        }

        return
    }

    postVideoEvent(
        payload: {
            video_url: string;
            video_location: string;
            video_location_id: string;
            sponsor_campaign_id: string | null;
        }
    ): void {
        this.postEvent('video_load', payload);
        setTimeout(() => this.postEvent('video_view', payload), 30000);
    }
}
